import { Assets } from './Assets';

export class Header {
  static getHeaderBody(headerLine1: string, headerLine2: string) {
    return `
        <div id="pageHeader" class="page-wrapper">
            <table id="header-table" class="full-width" cellspacing=0>
                <td align="left">
                    <img width="140px" src="${Assets.MM_Logo}" />
                </td>
                <td align="right" colspan="2">
                    <p class="p-heading ft-heading">${headerLine1}</p>
                    <p class="p-heading ft-heading">${headerLine2}</p>
                </td>
            </table>
            <hr class="headerbreak"/>
        </div>
        `;
  }

  static getHeaderStyle() {
    return `
        hr.headerbreak {
            border: none;
            background-color: #000;
            color: #000;
            height: 1px;
            padding: 0px;
            margin: 0px;
        }
        
        .header {
            position: fixed;
            top: 0;
        }
        
        .p-heading{text-align: right;margin-top: 0px;margin-bottom: 0px;}
        .ft-heading{font:bold 14px 'Times New Roman';line-height: 14px;}
        `;
  }
}
